export default __webpack_public_path__ + "locales/nl/Ldap.json?hash=6e4aaf76ab4299e75ae5ee2bba1b3e25";